module.exports = __webpack_public_path__ + "img/rain_red.7a7ca32f.gif";